import { gql } from '@apollo/client'

export const getWorkOrders = gql`
  query workOrders($input: WorkOrderInput!) {
    workOrders(input: $input) {
      workOrderID
      caseType
      location
      workOrderNumber
      priority
      workStatus
      grandTotal
      unitNumber
      street
      propertyID
    }
  }
`
